<cancelary-text-button *ngIf="showTrashIcon===false && showTextBtn===false"
                       (onClick)="showModal = true">
    {{ buttonName | translate }}
</cancelary-text-button>
<i *ngIf="showTrashIcon===true"
   class="fas fa-times btn-xs btn-bordered btn-danger btn-icon {{extraClasses}} {{inverseColor ? 'services-select__icon--inverse': ''}}"
   (click)="showModal = true"></i>

<a *ngIf="showTextBtn === true && !buttonName"
   (click)="showModal = true"
   class="btn btn-xs btn-bordered btn-danger text-uppercase float-right nglist-item-action"
   aria-hidden="true">{{'delete' | translate}}</a>

<a *ngIf="showTextBtn === true && buttonName !== '' && !noStyle"
   (click)="showModal = true"
   class="btn btn-xs btn-bordered btn-danger text-uppercase float-right nglist-item-action"
   aria-hidden="true">{{ buttonName | translate }}</a>

<a *ngIf="showTextBtn === true && buttonName !== '' && noStyle"
   (click)="showModal = true"
   class="{{ extraClasses }}"
   aria-hidden="true">{{ buttonName | translate }}</a>

<confirmation-modal [show]="showModal"
                    [buttonName]="buttonName"
                    [question]="question"
                    (isConfirmed)="handleConfirm($event)">
</confirmation-modal>